import React from "react";
import type { RowLayoutEntry } from "../../graphRows";

type HeaderEntry = Extract<RowLayoutEntry, { kind: "header" }>;

interface Props {
  entry: HeaderEntry;
  canSelect: boolean;
  totalCols: number;
  collapsedGroups?: Set<string>;
  onToggleGroup?: (key: string) => void;
  onRepeatLevel?: (zoneKey: string) => void;
  attachRowRef: (el: HTMLTableRowElement | null) => void;
}

const HeaderRow: React.FC<Props> = ({
  entry,
  canSelect,
  totalCols,
  collapsedGroups,
  onToggleGroup,
  onRepeatLevel,
  attachRowRef,
}) => {
  return (
    <tr ref={attachRowRef} className="dep-table-group-header-row">
      {canSelect && (
        <td className="dep-table-col-select dep-table-group-header" />
      )}
      <td
        colSpan={totalCols - (canSelect ? 1 : 0)}
        className={
          "dep-table-group-header" +
          (onToggleGroup ? " dep-table-group-header--toggle" : "")
        }
        onClick={onToggleGroup ? () => onToggleGroup(entry.key) : undefined}
        title={
          onToggleGroup
            ? collapsedGroups?.has(entry.key)
              ? "Expand this level"
              : "Collapse this level"
            : undefined
        }
      >
        {onToggleGroup && (
          <span className="dep-table-group-chevron" aria-hidden="true">
            {collapsedGroups?.has(entry.key) ? "▸" : "▾"}
          </span>
        )}
        <span className="dep-table-group-label">{entry.label}</span>
        <span className="dep-table-group-count">{entry.count}</span>
        {entry.hint && (
          <span className="dep-table-group-hint">{entry.hint}</span>
        )}
        {onRepeatLevel && entry.zone && (
          <button
            type="button"
            className="dep-table-group-repeat"
            title="Repeat this level — copy its activities and ties onto other floors"
            onClick={(e) => {
              e.stopPropagation();
              onRepeatLevel(entry.key.slice(2));
            }}
          >
            ⧉ repeat
          </button>
        )}
      </td>
    </tr>
  );
};

export default HeaderRow;
